import React from 'react';
import {Box, Button, makeStyles} from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Typography from "@material-ui/core/Typography";
import {createPatientFullName} from "@cabinet-packages/helpers";
import SidePanelMenu from "./SidePanelMenu";
import {useSelector} from "react-redux";
import {CustomDialog, QRCodeDialog} from "@cabinet-packages/components";

const useStyles = makeStyles((theme) => ({
    sideBox: {
        backgroundColor: 'white',
        paddingTop: '30px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 101,
        paddingBottom: '100px'
    },
    accountIcon: {
        fontSize: '120px',
        color: theme.palette.primary.main,
    },
    codeButton: {
        width: '50%',
        borderRadius: '20px',
        fontWeight: '700',
        margin: '20px 0px',
        border: '1px solid black'
    },
    fullNameText: {
        fontWeight: '700',
        padding: '0px 5px',
        textAlign: 'center',
        height: '50px'
    }
}))


const MobileAccountSettings = () => {
    const classes = useStyles()
    const {listOfPatients} = useSelector(state => state.patients);
    const foundPatient = listOfPatients && typeof listOfPatients !== 'string' && listOfPatients.find(currPatient => (currPatient.main));
    const {themeMaterialUI} = useSelector(store => store.theme);

    const showQRCode = (event) => {
        CustomDialog(QRCodeDialog, {
            QRCodeValue: `1234567809012345678901235${foundPatient.id}`,
        }, event, themeMaterialUI);
    };

    return (
        <Box className={classes.sideBox}>
            {foundPatient && (
                <>
                    <AccountCircleIcon className={classes.accountIcon}/>
                    <Typography className={classes.fullNameText}>
                        {createPatientFullName(foundPatient)}
                    </Typography>
                    {/*<Button onClick={showQRCode} variant="outlined" className={classes.codeButton}>QR Code</Button>*/}
                    <SidePanelMenu/>
                </>
            )}
        </Box>
    );
}

export default MobileAccountSettings;